import qs from 'qs';
import { axiosInstance } from './rest';

export function fetchWearables(params) {
  const requestData = {
    params: {
      ...params,
    },
    paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
  };
  return axiosInstance.get('/api/v2/wearables', requestData);
}

export function fetchWearableById(wearableId) {
  return axiosInstance.get(`/api/v2/wearables/${wearableId}`);
}

export function createWearable(data) {
  return axiosInstance.post('/api/v2/wearables', data);
}

export function updateWearable(wearableId, data) {
  return axiosInstance.put(`/api/v2/wearables/${wearableId}`, data);
}

export function deleteWearable(wearableId) {
  return axiosInstance.delete(`/api/v2/wearables/${wearableId}`);
}

export function fetchWearableHistory(wearableId, params) {
  const requestData = {
    params: {
      ...params,
    },
  };
  return axiosInstance.get(`/api/v2/wearables/${wearableId}/history`, requestData);
}

export function syncGatewayWearables(gatewayId) {
  return axiosInstance.post(`/api/v2/wearables/gateways/${gatewayId}/sync`);
}

export function fetchWearableAlarms(params) {
  const requestData = {
    params: {
      ...params,
    },
    paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
  };
  return axiosInstance.get('/api/v2/wearables/alarms', requestData);
}

export function updateWearableAlarm(alarmId, alarmDTO) {
  return axiosInstance.put(`/api/v2/wearables/alarms/${alarmId}`, alarmDTO);
}